import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import AuthContext from 'context/authContext';
import DonarFormContainer from './donor-form/DonorFormContainer';
import { useCreateDonor } from 'hooks/useDonors';
import { donorDraftStore } from './donor-form/donorDraft';

/* -------------------------------------------------------------------------- */
const CreateDonor = () => {
  const navigate = useNavigate();
  const { organization, selectedBranchId, user } = useContext(AuthContext);
  const { createDonorAsync, isCreating } = useCreateDonor();

  const handleCreate = async data => {
    try {
      const result = await createDonorAsync({
        ...data,
        branch_id: selectedBranchId,
        organisation_id: organization.id,
        remark: '' // Default empty remark
      });

      if (result?.data?.id) {
        donorDraftStore.clear(user?.id);
        navigate(`/donors/${result.data.id}/profile`);
      }
    } catch (error) {
      console.error('Create donor error:', error);
    }
  };

  return <DonarFormContainer loading={isCreating} onSubmit={handleCreate} />;
};

export default CreateDonor;
